<template>
  <van-search v-model="couponCode" :disabled="disabled" @search="onSearch" maxlength="16" placeholder="请输入优惠券的券码" show-action class="coupon-search">
    <template #action>
      <van-button class="coupon-search-button" type="primary" size="small" @click="onSearch" :disabled="disabled || !couponCode || couponCode.length < 9">券码兑换</van-button>&nbsp;&nbsp;
      <van-button class="coupon-search-button" type="primary" size="small" @click="scan" plain :disabled="disabled">扫码兑换</van-button>
    </template>
  </van-search>
</template>
<script>
import { Button, Dialog, Notify, Search } from "vant";

const component = {
  name: 'CouponInputer',
  components: {
    [Search.name] : Search,
    [Button.name] : Button
  },
  model: {
    event: 'code',
  },
  data() {
    return {
      couponCode : null
    }
  },
  props: {
    disabled : Boolean
  },
  methods: {
    onSearch() {
      if (this.couponCode && this.couponCode.length >= 9 && this.couponCode.length <= 16) {
        const code = this.couponCode.toUpperCase();
        this.$emit('code', code);
      } else {
        Notify("券码无效");
      }
    },
    scan() {
      Dialog.confirm({
        title: '扫码兑券',
        message: '扫描优惠券上的二维码选择此券',
        confirmButtonText: '扫一扫'
      })
        .then(() => {
          const that = this;
            this.$wechat.sdk(sdk => {
            sdk.scanQRCode({
              needResult: 1,
              success: res => {
                that.couponCode = res.resultStr;
                that.onSearch();
              }
            })
          });
        })
        .catch(() => {
          // on cancel
        });
    }
  }
}

export default component;
</script>
<style lang="less" scoped>
  .coupon-search-button{
    margin-bottom: 5px;
  }
</style>